(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.onScrollHandler = this.onScroll.bind(this);
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    }

    connectedCallback() {
      this.sectionHeader = this.closest('.section-header');
      this.isHomePage = document.body.classList.contains('template-index');

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size' ||
        this.isHomePage;

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.preventHide = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight);
      window.addEventListener('resize', this.setHeaderHeight);
      window.addEventListener('load', this.setHeaderHeight);

      const logo = this.querySelector('.header__heading-logo');
      if (logo && !logo.complete) {
        logo.addEventListener('load', this.setHeaderHeight);
      }

      this.resizeObserver = new ResizeObserver(() => {
        this.setHeaderHeight();
      });
      this.resizeObserver.observe(this);

      if (this.headerIsAlwaysSticky) {
        this.sectionHeader.classList.add('shopify-section-header-sticky');
      }

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const actualHeight = this.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${actualHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.setHeaderHeight);
      window.removeEventListener('load', this.setHeaderHeight);

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.sectionHeader);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.sectionHeader.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.sectionHeader.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.sectionHeader.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.sectionHeader.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.sectionHeader.classList.add('shopify-section-header-sticky', 'animate');
      this.sectionHeader.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.sectionHeader.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.sectionHeader.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.sectionHeader.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["power-footer"] && !Shopify.designMode) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vertical-tab-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
    const galleryTextSlide = () => {
        const cards = document.querySelectorAll('.gallery-with-text__card');

        cards.forEach(card => {
            card.addEventListener('mouseenter', function() {
                this.classList.add('active');
                cards.forEach(sibling => {
                    if (sibling !== this) {
                        sibling.classList.remove('active');
                    }
                });

                setTimeout(() => {
                    const overlay = this.querySelector('.gallery-with-text__info .link--overlay');
                    overlay.classList.add('active');

                    cards.forEach(sibling => {
                        if (sibling !== this) {
                            const siblingOverlay = sibling.querySelector('.gallery-with-text__info .link--overlay');
                            siblingOverlay.classList.remove('active');
                        }
                    });
                }, 100);
            });
        });
    };

    document.addEventListener('shopify:section:load', galleryTextSlide);
    galleryTextSlide();
})();


  } catch(e) { console.error(e); }
})();
})();
